import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/buttons/Button';

type Props = { title?: string; message: string; onRetry?: () => void };

export const ErrorState = ({ title, message, onRetry }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border border-red-200 bg-red-50 px-6 py-8 text-center">
      <TriangleAlert className="h-8 w-8 text-red-500" aria-hidden />
      <h3 className="text-base font-semibold text-red-700">{title ?? t('common.errorGeneric')}</h3>
      <p className="max-w-sm text-sm text-red-600">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} className="mt-2">
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
};
